import StoreProductImageFitSrc from "~/assets/img/store-product-image-original.png";
import {IIconBase} from "~/components/icons/_common/types";

interface BmStoreProductImageFitProps extends Omit<IIconBase, "size"> {}

export const BmStoreProductImageFit: React.FC<BmStoreProductImageFitProps> = ({id, className}) => {
  return <img src={StoreProductImageFitSrc} id={id} alt="Store product fit" className={className} />;
};
